module.exports = __webpack_public_path__ + "static/weaver-2-d86c239b47589e2bcf94278bb099564f.jpg";